const ROUTES = {
  COMPETENCY_MAPS: 'competency-maps',
  COMPANIES: 'companies',
  USERS: 'users',
  LOGIN: 'login',
  LOGS: 'logs',
};

export default ROUTES;
